module.exports = __webpack_public_path__ + "static/img/alipay_type.68844f42.jpg";